import { Api } from "./Api.class";
const endpoint = "beneficiary_statuses";
const beneficiaryStatusesAPI = new Api(endpoint);
export default beneficiaryStatusesAPI;
